import React from "react";
import "./Footer.scss";

function Footer(props) {
  return (
    <div className="footer">
      <hr />
      <p>&copy; Copyright 2024 - JHdev - Tous droits réservés</p>
    </div>
  );
}

export default Footer;
